import { useState } from "react";
import { useParams } from "react-router";
import { useEffect } from "react/cjs/react.development";
import { useGetData } from "..";
import { ENDPOINTS } from "../../constants/endpoints";
import FakeAvatar from "../../assets/mock/avatar_placeholder.png";
import FakeAvatar2 from "../../assets/mock/avatar_placeholder-2.png";
import FakeAvatar3 from "../../assets/mock/avatar_placeholder-3.png";
import GalleryImg from "../../assets/mock/gallery-img.png";

function randomDate(start, end) {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
}

const displayedCommentsMock = [
  {
    avatar: FakeAvatar,
    username: "Myrtie Runolfsson",
    comment:
      "We had the most spectacular view. Unfortunately it was very hot in the room from 2-830 pm due to no air conditioning and no shade.",
    star: 3,
    date: randomDate(new Date(2012, 0, 1), new Date()),
    images: [],
    responses: [
      {
        img: FakeAvatar2,
        comment: "Best place  stayed in all of NZ. 🙌 🎉 😎",
        date: randomDate(new Date(2012, 0, 1), new Date()),
      },
    ],
  },
  {
    avatar: FakeAvatar3,
    username: "Michael May",
    comment:
      "Stunning views of Queenstown. Very peaceful. Love it so much. Definitely gonna come back and visit.",
    star: 5,
    date: randomDate(new Date(2012, 0, 1), new Date()),
    images: [GalleryImg, GalleryImg, GalleryImg],
    responses: [],
  },
  {
    avatar: FakeAvatar3,
    username: "Tobin Hackett",
    comment: "Best place I stayed in all of NZ. 🙌 🎉 😎",
    star: 4,
    date: randomDate(new Date(2012, 0, 1), new Date()),
    images: [],
    responses: [],
  },
];

function useCompanyCommentLogic({ reviews }) {
  const { company } = useParams();
  const [displayedComments, setDisplayedComments] = useState(
    displayedCommentsMock
  );

  console.log({ reviews });

  /*   const { data } = useGetData(
    `${ENDPOINTS.GET.SERVICES}${company}/reviews`,
    true
  ); */

  /*   useEffect(() => {
    const comments = data?.hits?.data || [];

    if (comments) {
      setDisplayedComments(comments);
    }
  }, [data]); */

  return { displayedComments, setDisplayedComments };
}

export default useCompanyCommentLogic;
